import React, { createContext, useState, useContext } from 'react';

// Creëer een nieuwe context voor taalbeheer
const LanguageContext = createContext();

// Maak een custom hook om de taal te gebruiken
export const useLanguage = () => {
    return useContext(LanguageContext);
};

// Maak een provider om de taal te beheren
export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('nl');  // Standaard is de taal Nederlands

    const toggleLanguage = () => {
        setLanguage((prevLang) => (prevLang === 'nl' ? 'en' : 'nl'));
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
